// This file is auto-generated by the generate:i18n script.
// Do not edit this file manually.

export const languages = ["en","es","fi","sv"] as const
export const namespaces = ["admin","common","contactRequest","contacts","events","feed","feedback","home","interest","leads","notes","pro","property","sourceViewer","traits","user","validation"] as const

export type Language = (typeof languages)[number]
export type Namespace = (typeof namespaces)[number]
